import styled from "styled-components";
import { Popup } from "react-leaflet";

export const CardInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 146px;
  border-radius: 10px;
  gap: 5px;

  svg {
    /* color: #fff; */
    color: ${(props) => (props.color ? props.color : "black")};
    /* font-size: 30px; */
  }

  p {
    font-weight: 500;
    font-size: 13px;
    /* color: ${(props) => (props.color ? props.color : "black")}; */
  }

  span {
    font-size: 18px;
  }
`;

export const ModalStyles = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex-direction: column;
  position: relative;
`;

export const FlexBottom = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
  width: max-content;

  @media (max-width: 700px) {
    width: auto;
  }
`;

export const DivCloseButton = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 9999;

  @media (max-width: 700px) {
    top: 4px;
  }

  button {
    font-size: 20px;
    color: white;
    min-width: unset;
    padding: 0;

    span {
      margin: 0;
    }
  }
`;

export const List = styled.ul`
  list-style: none;
  padding-left: 6px;
  margin: 10px 0 10px 0px;
  align-items: center;
  /* height: 81%; */
  justify-content: center;
  border-left: 1px solid;
  text-align: center;
  justify-content: center;
  align-items: center;
  li + li {
    margin-top: 1px;
  }
`;

export const Teste = styled.div`
  background-color: white;
  border: 4px solid
    ${(props) =>
      props.color
        ? props.color === "black"
          ? "#6d6d6d"
          : props.color
        : "white"};
  border-radius: 13px;
  // box-shadow: 0 3px 14px rgba(0, 0, 0, 0.4);
  box-shadow: rgba(0, 0, 0, 0.8) 2px 2px 10px;
  cursor: pointer;
`;

export const LegendMap = styled.div`
  position: absolute;
  height: auto;
  width: auto;
  z-index: 999999;
  color: black;
  padding: 10px;
  right: 5px;
  top: 115px;
  table {
    width: 100%;
    border-collapse: collapse;
  }

  th,
  td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: center;
  }

  th {
    background-color: #f2f2f2;
    font-weight: bold;
  }

  h3 {
    font-size: 1.2em;
    margin-bottom: 10px;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    margin: 5px 0;
  }
`;

export const Bubles = styled.div`
  border: 1px solid blue;
  padding: 5px;
  border-radius: 50%;
`;

export const StyledPop = styled(Popup)`
  .leaflet-popup-content-wrapper {
    border: ${(props) =>
      props.color ? `2px solid ${props?.color}` : `none`} !important;

    /* border: 2px solid red */
  }
`;

export const TitleCardNew = styled.div`
  position: absolute;
  top: -21px;
  justify-content: center;
  align-items: center;
  display: flex;
  width: 90%;

  h2 {
    background-color: ${(props) => (props.color ? props.color : "transparet")};
    padding: 0 2px;
    border-radius: 4px;
  }

  color: white;
`;

export const BorderDivisor = styled.div`
  width: 90%;
  height: 1px;
  background-color: black;
`;

export const Circle = styled.div`
  width: 100%;
  border-radius: 50%;
  color: black;
  border: 2px solid ${(props) => (props.color ? props.color : "black")};
  width: ${(props) => (props.size ? props.size : "25px")};
  height: ${(props) => (props.size ? props.size : "25px")};
  align-items: center;
  display: flex;
  justify-content: center;
`;

export const PLineHeigth = styled.div`
  line-height: 1;
  font-weight: 500;
  font-size: 13px;
  padding: 0 7px;
`;

export const PLineHeigth2 = styled.div`
  line-height: 1;
  font-weight: 400;
  font-size: 11px;
  position: relative;
  top: -3px;
  color: #8b8000;
`;

export const SelectMapGeojson = styled.div`
  position: absolute;
  z-index: 1200;
  background-color: white;
  width: 188px;
  height: auto;
  // top: calc(50% - 64px);
  top: 160px;
  right: 50px;
  padding: 10px;
`;
